import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceMarkMilestoneAsCompletedNotificationState = createStateReducer(
  initialState,
  {
    [events.markMilestoneAsCompletedSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "markMilestoneAsCompleted",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.markMilestoneAsCompletedFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "markMilestoneAsCompleted",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceMarkMilestoneAsCompletedNotificationState };
